module.exports = __webpack_public_path__ + "static/media/image9.e5107306.png";